<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

:root {
  /* Couleurs principales */
  --primary-color: var(--whatsapp-green);
  --primary-light: rgba(37, 211, 102, 0.08);
  --secondary-color: #6c757d;
  
  /* Couleurs de fond */
  --bg-color: #f5f5f5;
  --bg-white: #fff;
  --bg-light: #f8fafc;
  
  /* Couleurs de texte */
  --text-color: #333;
  --text-muted: #6b7280;
  
  /* Couleurs utilitaires */
  --border-color: #e1e5eb;
  --hover-bg: #f0f2f5;
  --input-bg: ##f5f5f5;
  --gray-color: #9ca3af;
  --success-color: #10b981;
  --background-listuser: #f0f0f0;
  
  /* Couleurs WhatsApp */
  --whatsapp-green: #25D366;
  --whatsapp-dark: #075E54;
}

html, body {
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  background-color: var(--bg-color);
}

#app {
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;
}

img {
  max-width: 100%;
  height: auto;
}

button, a {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Styles pour résoudre le problème de la barre latérale */
.main-content {
  margin-left: 240px;
  width: 100% !important;
  max-width: 100% !important;
}

.dashboard  {
  background: #f5f5f5 !important;

}
</style>
